import { render, staticRenderFns } from "./DistributePictureModal.vue?vue&type=template&id=8a7a5120&scoped=true&lang=pug"
import script from "./DistributePictureModal.vue?vue&type=script&lang=ts"
export * from "./DistributePictureModal.vue?vue&type=script&lang=ts"
import style0 from "./DistributePictureModal.vue?vue&type=style&index=0&id=8a7a5120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7a5120",
  null
  
)

export default component.exports